import { Button, Typography, useTheme } from '@mui/material'

import { PlanPrices } from './plan-prices.component'
import { IBillingPlan } from 'src/types'
import { useStyles } from './styles'
import { BillingIcon, IIcons } from './v2/BillingIcon'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { FireIcon } from 'src/assets/icons/v2/FireIcon'
import { PlantIcon } from 'src/assets/icons/v2/PlantIcon'

interface IBillingPlanProps extends IBillingPlan {
  yearlyCalculation?: string
  discount?: string
  buttonText: string
  buttonDisabled?: boolean
  isActivated?: boolean
  value: number
  popularChoice?: boolean
  onButtonClick?: () => void
  doNotShow?: boolean
  showExpired: boolean
}

const BillingPlan = (props: IBillingPlanProps) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div style={{ display: props.doNotShow ? 'none' : 'flex' }} className={classes.mainPlanWrapper}>
      <div className={classes.planIcon}>
        {props.isActivated ? (
          <div className={classes.iconWrapper} style={{ color: theme.palette.custom.grey2 }}>
            <PlantIcon size={22} />
            <HelperWrapper t={'current-plan-price'} />
          </div>
        ) : props.popularChoice ? (
          <div className={classes.iconWrapper} style={{ color: theme.palette.primary.main }}>
            <FireIcon size={22} />
            <HelperWrapper t={'popular-choice-price'} />
          </div>
        ) : (
          <div className={classes.iconWrapper} />
        )}
      </div>
      <div
        className={`${props.popularChoice ? classes.popularChoice : classes.itemBorder} ${
          classes.planWrapper
        } ${props.isActivated ? classes.planWrapperActive : ''}`}
      >
        <div className={classes.planUpper}>
          <h3 className={classes.planTitle}>
            {props.title}

            {props.showExpired && (
              <Typography
                sx={{
                  position: 'absolute',
                  top: '0px',
                  right: '0px',
                  fontStyle: 'italic',
                  transform: 'translateX(100%)',
                  fontSize: '12px',
                  fontWeight: 700,
                  color: theme.palette.custom.warning2,
                }}
              >
                Expired
              </Typography>
            )}
          </h3>
          <BillingIcon value={props.value as keyof IIcons} />
          {props.monthlyFee && props.yearlyFee && (
            <PlanPrices
              discount={props.discount}
              monthlyFee={props.monthlyFee}
              yearlyFee={props.yearlyFee}
              yearlyCalculation={props.yearlyCalculation}
            />
          )}
        </div>
        <div style={{ flexGrow: 1 }} />
        <ul className={classes.planDescriptionList}>
          {props.description.map((text) => (
            <li key={text}>
              <p className={classes.planDescriptionText}>{text}</p>
            </li>
          ))}
        </ul>
        <Button
          variant="contained"
          type="button"
          disabled={props.buttonDisabled}
          className={classes.planButton}
          onClick={props.onButtonClick}
        >
          {props.buttonText}
        </Button>
      </div>
    </div>
  )
}

export { BillingPlan }
